 //PLMSolutionsAMCPage.jsx
import React, { useState } from "react";
import "./PLMSolutionsAMCPage.css";
import PLMSolutionsAMCOverview from "./PLMSolutionsAMCOverview";
import BannerImage from "../../../assets/other_image/Amc.jpg"; // update path if needed
import Letsgetintouch from "../../PLMImplementation/BusinessProcessAndChangeManagement/Letsgetintouch";
import Banner from "../SolutionBanner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import BookDemoSection from "../PolarianALMSolution/BookDemoSection";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
/**
 * PLMSolutionsAMCPage.jsx
 * - Keeps the same JSX layout structure as PolarianALMSolutionPage.jsx
 * - Replaces text/images with Teamcenter AMC content provided by the user
 * - Adds "NexTech’s Unique Process to Get AMC Done" section
 */

/* FAQ data (Teamcenter AMC) */
const faqData = [
  { question: "What is Teamcenter AMC and why is it needed?", answer: "AMC ensures Teamcenter PLM is reliable, up-to-date, and optimized for business performance. Without it, organizations risk downtime, inefficiencies, and underutilization of PLM investments." },
  { question: "How does NexTech AMC differ from standard IT support?", answer: "Unlike generic IT support, NexTech provides specialized PLM expertise, covering administration, development, performance tuning, and business-aligned enhancements." },
  { question: "What industries benefit from Teamcenter AMC?", answer: "Our AMC supports diverse industries including manufacturing, automotive, aerospace, energy, and more—anywhere Teamcenter is deployed." },
  { question: "Can AMC be customized?", answer: "Yes. Clients can choose scope, duration, and delivery model (onsite, offsite, or hybrid) for cost efficiency and flexibility." },
  { question: "Does AMC cover new feature development?", answer: "Absolutely. AMC includes both new capability development and redefining outdated solutions to align with evolving business needs." },
  { question: "How does NexTech ensure system security?", answer: "Our experts follow strict data privacy protocols and industry best practices to ensure confidentiality and compliance." },
  { question: "What is the typical duration of engagement?", answer: "AMC engagement is for one year, with annual renewal for uninterrupted support and system reliability." }
];

const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="faq-item">
      <button className="faq-question" onClick={() => setOpen(!open)} aria-expanded={open}>
        <span>{question}</span>
        <span>{open ? "−" : "+"}</span>
      </button>
      {open && <div className="faq-answer">{answer}</div>}
    </div>
  );
};

const SectionHeader = ({ title, subtitle }) => (
  <header className="section-header">
    <h2 className="section-title">{title}</h2>
    {subtitle && <p className="section-subtitle">{subtitle}</p>}
  </header>
);

const TileGrid = ({ items }) => (
  <div className="tile-grid-3x2">
    {items.map((item, index) => (
      <article className="feature-tile" key={index}>
        {item.icon && (
          <div className="tile-icon">
            <img src={item.icon} alt={item.title} width="48" height="48" />
          </div>
        )}
        <h3 className="tile-title">{item.title}</h3>
        <p className="tile-content">{item.content}</p>
      </article>
    ))}
  </div>
);

const PLMSolutionsAMCPage = () => {
  /* Benefit tiles */
  const whyNextechItems = [
    { icon: "https://img.icons8.com/fluency/48/globe-earth.png", title: "Global Expertise", content: "Proven PLM support service across industries worldwide." },
    { icon: "https://img.icons8.com/fluency/48/employee-card.png", title: "Dedicated Experts", content: "Skilled PLM professionals committed to excellence." },
    { icon: "https://img.icons8.com/fluency/48/privacy.png", title: "Data Security", content: "Absolute assurance of data privacy with trusted PLM experts." },
    { icon: "https://img.icons8.com/fluency/48/maintenance.png", title: "Mission-Critical Specialization", content: "Tailored support for complex PLM environments." },
    { icon: "https://img.icons8.com/fluency/48/money-bag.png", title: "Cost-Optimized Models", content: "Flexible onsite, offsite, or hybrid support models." },
    { icon: "https://img.icons8.com/fluency/48/combo-chart.png", title: "Business Alignment", content: "Maximize Teamcenter usage to meet strategic goals." }
  ];

  const ourSolutionsItems = [
    { icon: "https://img.icons8.com/fluency/48/technical-support.png", title: "Technical Support", content: "Day-to-day issue resolution and best-practice enablement, including support for linked apps like SE, MSO, etc." },
    { icon: "https://img.icons8.com/fluency/48/server.png", title: "System Administration", content: "Monitoring & maintaining production/database servers, performance tuning, patching, and OS/hardware upgrades." },
    { icon: "https://img.icons8.com/fluency/48/services.png", title: "Solution Development", content: "Developing new capabilities for manufacturing, change management, CAD-BOM alignment, CAE data management, and redefining existing solutions for efficiency." },
    { icon: "https://img.icons8.com/fluency/48/test-passed.png", title: "Regression Testing", content: "Structured testing of new or updated functionalities to ensure functional stability and reliability." },
    { icon: "https://img.icons8.com/fluency/48/training.png", title: "Usage-Centric Training", content: "Training for new users/modules, creation of knowledge bases, user manuals, and contextual day-to-day use case training." },
    { icon: "https://img.icons8.com/fluency/48/restart.png", title: "Continuous Support & Renewal", content: "One-year AMC engagement with annual renewals for uninterrupted support." }
  ];

  return (
<>
      {/* ✅ Meta Tags for SEO */}
    <Helmet>
      <title>PLM Solutions AMC Services in Pune | Nextech PLM</title>
      <meta name="description" content="Ensure continuous performance with PLM Solutions AMC services in Pune, India. Nextech PLM offers reliable support for your Teamcenter systems." />
      <meta name="keywords" content="PLM AMC services Pune, Teamcenter annual maintenance India, PLM support contract, Teamcenter AMC, PLM system maintenance" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href="https://nextechplm.com/teamcenter-plm-solutions-amc" />
      <meta property="og:site_name" content="NexTech PLM Solutions" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="PLM Solutions AMC Services in Pune | Nextech PLM" />
      <meta property="og:description" content="Ensure continuous performance with PLM Solutions AMC services in Pune, India. Nextech PLM offers reliable support for your Teamcenter systems." />
      <meta property="og:url" content="https://nextechplm.com/teamcenter-plm-solutions-amc" />
      <meta name="twitter:title" content="PLM Solutions AMC Services in Pune | Nextech PLM" />
      <meta name="twitter:description" content="Ensure continuous performance with PLM Solutions AMC services in Pune, India. Nextech PLM offers reliable support for your Teamcenter systems." />
</Helmet>

<main className="polarion-solution-page">
      <Banner image={BannerImage} heading="Teamcenter Solutions AMC" />
      <FloatingContactUs />
      {/* Note: Reusing the overview component for layout consistency; content below replaces Polarion text */}
      <PLMSolutionsAMCOverview />

      <section className="section benefits-section">
        <div className="container">
          <div className="row g-4 align-items-center">
            
            {/* Benefits */}
            <div className="col-md-6 col-12">
              <div className="benefits-card">
                <h3 className="benefits-heading">Benefits of NexTech Teamcenter AMC</h3>
                <ul className="benefits-list">
                  <li><span className="benefit-icon">✔</span> Global Expertise: Proven PLM support service across industries worldwide.</li>
                  <li><span className="benefit-icon">✔</span> Dedicated Experts: Skilled PLM professionals committed to excellence.</li>
                  <li><span className="benefit-icon">✔</span> Data Security: Absolute assurance of data privacy with trusted PLM experts.</li>
                  <li><span className="benefit-icon">✔</span> Mission-Critical Specialization: Tailored support for complex PLM environments.</li>
                  <li><span className="benefit-icon">✔</span> Cost-Optimized Models: Flexible onsite, offsite, or hybrid support models.</li>
                  <li><span className="benefit-icon">✔</span> Business Alignment: Maximize Teamcenter usage to meet strategic goals.</li>
                </ul>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-md-6 col-12 d-flex align-items-center">
              <div className="quick-links">
                <h4>Quick Links</h4>
                <ul>
                  <li><NavLink to={"/teamcenter/plm-document-management"}>Document Management</NavLink></li>
                  <li><NavLink to={"/teamcenter/manufacturing-data-process-management"}>Manufacturing Data and Process Management</NavLink></li>
                  <li><NavLink to={"/teamcenter/product-bom-variability-management"}>Product BOM and Variability Management</NavLink></li>
                  <li><NavLink to={"/teamcenter/community-collaboration"}>Teamcenter Community Collaboration</NavLink></li>
                  <li><NavLink to={"/teamcenter/cloud-implementation"}>Teamcenter Implementation on Cloud</NavLink></li>
                  <li><NavLink to={"/teamcenter/ecad-integration"}>ECAD Integration</NavLink></li>
                  <li><NavLink to={"/teamcenter/mcad-integration"}>MCAD Integration</NavLink></li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>

      <BookDemoSection />

      <section className="section featured-solutions-section">
        <div className="container">
          <SectionHeader title="Our Services" subtitle="NexTech’s AMC services cover end-to-end support and enhancement of Teamcenter PLM." />
          <TileGrid items={ourSolutionsItems} />
        </div>
      </section>

      <section className="section our-solutions-section">
        <div className="container">
          <SectionHeader title="Why NexTech for Teamcenter Solutions AMC?" />
          <p className="section-intro">
            Choosing NexTech means choosing reliability, expertise, and customer-first service.
          </p>
          <TileGrid items={whyNextechItems} />
          <p className="section-outro">
            With our proven track record and certified PLM experts, NexTech ensures your Teamcenter investment consistently drives business outcomes.
          </p>
        </div>
      </section>

      {/* New Section: NexTech’s Unique Process to Get AMC Done */}
      <section className="section nextech-amc-section">
        <div className="container">
          <SectionHeader title="NexTech’s Unique Process to Get AMC Done" />
          <p className="section-intro">
            We follow a structured and transparent AMC process to ensure clarity and measurable outcomes:
          </p>

          <div className="amc-process-card">
            <ul className="amc-process-list">
              <li>
                <h4>PLM SME Visit</h4>
                <p>Onsite assessment of current system (“As-Is” analysis).</p>
              </li>
              <li>
                <h4>Requirement Specification</h4>
                <p>Documenting AMC scope tailored to customer needs.</p>
              </li>
              <li>
                <h4>Customer Agreement</h4>
                <p>Defining timelines, deliverables, and SLAs.</p>
              </li>
              <li>
                <h4>Execution</h4>
                <p>Implementation of AMC with proactive monitoring.</p>
              </li>
              <li>
                <h4>Bi-Annual Audit</h4>
                <p>Every 6 months, progress and effectiveness review.</p>
              </li>
            </ul>
          </div>

          <p className="section-outro">
            With NexTech’s Teamcenter Solutions AMC, you gain a reliable, future-ready PLM ecosystem that drives business performance, efficiency, and innovation.
          </p>
        </div>
      </section>

      <section className="section faq-section">
        <div className="container">
          <SectionHeader title="FAQs – Teamcenter Solutions AMC" />
          <div className="faq-container">
            {faqData.map((item, i) => (
              <FAQItem key={i} question={item.question} answer={item.answer} />
            ))}
          </div>
        </div>
      </section>

      <Letsgetintouch />
    </main>
</>
  );
};

export default PLMSolutionsAMCPage;
